import {
  URL_REGEX,
  EMAIL_REGEX,
  EMAIL_MAX_LENGTH,
} from 'constants/validateRules';

export const isCorrectUrlFormat = (url: string): boolean => {
  return URL_REGEX.test(url);
};

export const isValidEmail = (email?: string | null): boolean =>
  !!email && email.length <= EMAIL_MAX_LENGTH && EMAIL_REGEX.test(email);
